const ArrayTableHeader = ({fields}) => {
    const headers = Object.keys(fields).map( (field) => <th>{fields[field].label}</th>)
    return <thead>
        <tr>
            {headers}
        </tr>
    </thead>
}
export default ArrayTableHeader